



















































































import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import FileDetailNavigationDrawer from '@/components/storage/drawers/FileDetailNavigationDrawer.vue';
import ShowFilePreviewModal from '@/components/storage/modals/ShowFilePreviewModal.vue';
import { FindDirectoryDetail, FindDirectoryFileDetail, findDirectoryQueryDto } from '@/@types/Directory';
import { FileInfo } from '@/@types/File';
import { vxm } from '@/store';

@Component({
  components: {
    FileDetailNavigationDrawer,
    ShowFilePreviewModal,
  },
})
export default class CardView extends Vue {
  @Model('change', { type: Array })
  public readonly checkBoxArray!: Array<number>;

  @Prop({ required: true })
  private searchWord!: string;

  private fileId: number = 0;

  private fileName: string = '';

  private isShowFilePreviewModal: boolean = false;

  private isOpenPropertydrawer: boolean = false;

  private cardHeight: string = '180px';
  // private isOpenPropertydrawer: boolean = false;

  private fileInfo: FileInfo | null = null;
  private objectType: string = '';
  private objectName: string = '';
  private objectSize: string = '';
  private objectPath: string = '';
  private objectOwner: string = '';
  private objectChangeDate: Date = new Date();
  private objectChanger: string = '';
  private objectOwnerIcon: string = '';
  private objectChangerIcon: string = '';

  private selectedDirectoryPutArray(index: number): Array<number> {
    if (this.checkBoxArray.includes(index)) {
      const checkIndex: number = this.checkBoxArray.indexOf(index);
      return this.checkBoxArray.splice(checkIndex, 1);
    } else {
      this.checkBoxArray.push(index);
      return this.checkBoxArray;
    }
  }

  private selectedFilePutArray(index: number): Array<number> {
    const fileIndex = index + this.directories.length;
    if (this.checkBoxArray.includes(fileIndex)) {
      const checkIndex: number = this.checkBoxArray.indexOf(fileIndex);
      return this.checkBoxArray.splice(checkIndex, 1);
    } else {
      this.checkBoxArray.push(fileIndex);
      return this.checkBoxArray;
    }
  }

  private isSelectedDirectory(directoryIndex: number): boolean {
    if (this.checkBoxArray.includes(directoryIndex)) {
      return true;
    } else {
      return false;
    }
  }

  private isSelectedFile(index: number): boolean {
    if (this.checkBoxArray.includes(index + this.directories.length)) {
      return true;
    } else {
      return false;
    }
  }

  private openShowFilePreviewModal(file: FindDirectoryFileDetail): void {
    this.fileId = file.fileId;
    this.fileName = file.fileName;
    this.isShowFilePreviewModal = true;
  }

  private closeShowFilePreviewModal() {
    this.isShowFilePreviewModal = false;
  }

  private switchDirectoryDetailDrawer(directory: FindDirectoryDetail): void {
    if (!this.isOpenPropertydrawer) {
      this.objectType = 'Directory' ;
      this.objectName = directory.directoryName;
      this.objectSize = '';
      this.getDirectoryPathFromParent(directory.parentDirectoryId); // this function will update this.objectPath
      this.objectOwner = directory.accountName;
      this.objectOwnerIcon = '';
      if (directory.updateAccountName) {
        this.objectChanger = directory.updateAccountName;
        this.objectChangerIcon = '';
      } else {
        this.objectChanger = directory.accountName;
        this.objectChangerIcon = '';
      }
      if (directory.updatedAt) {
        this.objectChangeDate = directory.updatedAt;
      } else {
        this.objectChangeDate = directory.createdAt;
      }
      this.objectChangeDate = new Date(this.objectChangeDate);
    }
    this.isOpenPropertydrawer = !this.isOpenPropertydrawer;
  }

  private async getDirectoryPathFromParent(parentDirectoryId: number | null) {
    const query: findDirectoryQueryDto = {
      'project-id':vxm.theoryApi.authStore.getCurrentProjectId!
    };
    let currentDirectory: FindDirectoryDetail | undefined = undefined;
    let path: string = '';

    while (parentDirectoryId) {
      await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:parentDirectoryId,query:query});
      if (vxm.theoryApi.directoriesStore.getParentDirectory) {
        currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
        parentDirectoryId = currentDirectory.parentDirectoryId;
        path = `${currentDirectory.directoryName}\\${path}`;
      }
    }
    path = `\\\\${path}`;
    this.objectPath = path;
  }

  private async getDirectoryPathFromCurrent(currentDirectoryId: number) {
    const query: findDirectoryQueryDto = {
      'project-id':vxm.theoryApi.authStore.getCurrentProjectId!
    };
    let currentDirectory: FindDirectoryDetail | undefined = undefined;
    let parentDirectoryId: number | null = null;
    let path: string = '';

    await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:currentDirectoryId,query:query});
    if (vxm.theoryApi.directoriesStore.getParentDirectory) {
      currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
      parentDirectoryId = currentDirectory.parentDirectoryId;
      path = currentDirectory.directoryName;
      while (parentDirectoryId) {
        await vxm.theoryApi.directoriesStore.fetchParentDirectory({directoryId:parentDirectoryId,query:query});
        if (vxm.theoryApi.directoriesStore.getParentDirectory) {
          currentDirectory = vxm.theoryApi.directoriesStore.getParentDirectory.results;
          parentDirectoryId = currentDirectory.parentDirectoryId;
          path = `${currentDirectory.directoryName}\\${path}`;
        }
      }
      path = `\\\\${path}\\`;
      this.objectPath = path;
    }
  }

  private switchFileDetailDrawer(file: FindDirectoryFileDetail): void {
    if (!this.isOpenPropertydrawer) {
      vxm.theoryApi.filesStore.fetchFileInfo({fileId:file.fileId,projectId:vxm.theoryApi.authStore.getCurrentProjectId!}).then(() => {
        const fileInfo = vxm.theoryApi.filesStore.getFileInfo;
        if (fileInfo) {
          this.objectName = fileInfo.fileName;
          this.objectType = this.getFileExtension(fileInfo?.fileName)!.toUpperCase() ;
          this.getDirectoryPathFromCurrent(fileInfo.directoryId!).then(()=> { // this function will update this.objectPath
            if (fileInfo) {
              if (fileInfo.accountName) {
                this.objectOwner = fileInfo.accountName;
                this.objectOwnerIcon = fileInfo.iconImage;
                this.objectChanger = fileInfo.accountName;
                this.objectChangerIcon = fileInfo.iconImage;
              } else {
                this.objectOwner = '';
                this.objectOwnerIcon = '';
                this.objectChanger = '';
                this.objectChangerIcon = '';
              }
              if (fileInfo.updatedAt) {
                this.objectChangeDate = fileInfo.updatedAt;
              } else {
                this.objectChangeDate = fileInfo.createdAt;
              }
              this.objectChangeDate = new Date(this.objectChangeDate);
            }
          });
        }
        this.objectSize = '';
      });
    }
    this.isOpenPropertydrawer = !this.isOpenPropertydrawer;
  }

  private getFileExtension(fileName:string) {
    const ext = fileName.match(/[^.]+$/);
    if (ext) {
      return ext.toString();
    }
  }

  private closeDetailDrawer(): void {
    this.isOpenPropertydrawer = false;
  }

  private get directories() {
    const directories = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.directories ?? [];
    return this.searchWord ? directories.filter((d) => d.directoryName.includes(this.searchWord)) : directories;
  }

  private get files() {
    const files = vxm.theoryApi.directoriesStore.getCurrentDirectoryAndFiles?.results.files ?? [];
    return this.searchWord ? files.filter((f) => f.fileName.includes(this.searchWord)) : files;
  }
}
